import MaterialIcon from '@components/common/MaterialIcon';
import clsx from 'clsx';
import type React from 'react';

interface SidebarProfileMenuRowProps {
  icon: string;
  label: string;
  // Optional icon shown on the right (e.g. chevron_right, arrow_drop_down)
  trailingIcon?: string;
  // Rotate the trailing icon 180deg (used for the language expand/collapse arrow)
  trailingIconRotated?: boolean;
  // Destructive action styling (red tint on icon + text)
  danger?: boolean;
}

export const SidebarProfileMenuRow: React.FC<SidebarProfileMenuRowProps> = ({
  icon,
  label,
  trailingIcon,
  trailingIconRotated,
  danger,
}) => {
  return (
    <div className='flex items-center gap-3 px-3 py-2'>
      <MaterialIcon
        icon={icon}
        type='outlined'
        classes={[
          'text-sm',
          danger ? 'text-red-500' : 'text-gray-600',
          'flex-shrink-0',
          'leading-none',
        ]}
      />
      <span
        className={clsx(
          'text-tiny flex-1',
          danger ? 'text-red-600 font-medium' : 'text-gray-600',
        )}>
        {label}
      </span>
      {trailingIcon && (
        <MaterialIcon
          icon={trailingIcon}
          classes={[
            'text-sm',
            'text-gray-400',
            'flex-shrink-0',
            'leading-none',
            // Only the expandable arrow needs a rotation transition
            ...(trailingIconRotated === undefined
              ? []
              : [trailingIconRotated ? 'rotate-180 transition' : 'transition']),
          ]}
        />
      )}
    </div>
  );
};

export default SidebarProfileMenuRow;
